import { Component, OnInit } from '@angular/core';
import { SurveyDetailsTableConfig } from './survey-details.table-config';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
import { FormGroupService, FormService, SurveyService } from '@app/services';
import { FormBuilderService } from '@app/form-builder/form-builder/form-builder-service.service';
import { AppNotification } from '@app/helpers';

const NEW_GROUP = {
  name: "",
  type: "standard"
};

@Component({
  selector: 'app-survey-details',
  templateUrl: './survey-details.component.html',
  styleUrls: ['./survey-details.component.scss']
})
export class SurveyDetailsComponent implements OnInit {

  tableConfig: any;
  surveyId: string | null;
  formList: any[] = [];
  selectedForm: any;

  isAddNewGroupPopup: boolean = false;
  newGroup: any = NEW_GROUP;

  groupList: any[] = [];
  groupForms: any = {};

  alertFormDelete = {
    visible: false,
    form: {}
  };

  alertSurveyDelete = {
    visible: false
  }

  editGroupPopup: any = {
    visible: false,
    group: null,
    newName: ""
  }

  formAndGroupList: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formService: FormService,
    private formBuilderService: FormBuilderService,
    private formGroupService: FormGroupService,
    private surveyService: SurveyService
  ) { }

  ngOnInit(): void {
    this.surveyId = this.route.snapshot.queryParamMap.get('surveyId');
    if (this.surveyId == null) {
      this.router.navigate([APP_ROUTES.SURVEY])
      return
    }
    this.tableConfig = SurveyDetailsTableConfig.configure()
    this.getList();
    this.listGroups();
  }

  getList() {
    this.formList = [];
    this.formService.list(this.surveyId).subscribe({
      next: (res: any) => {
        this.groupForms = {};
        res.data.forEach((form: any) => {
          if (!form.groupId) {
            this.formList.push(form)
            return
          }

          if (!this.groupForms[form.groupId]) {
            this.groupForms[form.groupId] = []
          }
          this.groupForms[form.groupId].push(form)
        })
        this.formAndGroupList = this.formList.concat(this.groupList).sort((a, b) => (a.seqNo - b.seqNo))
        if (res.data.length) this.selectForm(this.formList[0])
      }
    })
  }

  gridActions(e: any, group?: any) {
    if (e.button?.eventName == "edit") {
      this.router.navigate([APP_ROUTES.FORM_BUILDER], {
        queryParams: { formId: e.data._id }
      })
    }
    if (e.button?.eventName == "add") {
      this.router.navigate([APP_ROUTES.FORM_BUILDER], {
        queryParams: { surveyId: this.surveyId, groupId: group?._id }
      })
    }
    if (e.eventName == "row-selected") {
      this.selectForm(e.data)
    }

    if (e.button?.eventName == "delete") {
      this.alertFormDelete = {
        visible: true,
        form: e.data
      }
      // this.deleteForm(e.data)
    }
    if (e.button?.eventName == "publish") {
      this.publishForm(e.data)
    }
    if (e.button?.eventName == "add-group") {
      this.isAddNewGroupPopup = true;
    }
    if (e.button?.eventName == "delete-survey") {
      this.alertSurveyDelete.visible = true;
    }
    if (e.eventName == "re-order") {
      this.updateFormReorder(e.data);
    }

    if (e.button?.eventName == "edit-formGroup") {
      this.editGroupPopup = {
        visible: true,
        group: group,
        newName: group.name
      }
    }

    if (e.button?.eventName == "delete-formGroup") {
      this.onDeleteFormGroup(group);
    }
  }

  publishForm(formObj: any) {
    this.formService.publish(formObj._id).subscribe({
      next: (res: any) => { this.getList() },
      error: (error: any) => { console.log(error) }
    })
  }

  deleteForm(formObj: any) {
    console.log(formObj)
    this.formService.delete(formObj._id).subscribe({
      next: (res: any) => { this.getList() },
      error: (error: any) => { console.log(error) }
    })
  }

  selectForm(formObj: any) {
    this.selectedForm = formObj
    try {
      let formJson: any = JSON.parse(formObj.formJson)

      this.formBuilderService.components = formJson.added_components;
      this.formBuilderService.formDesign = formJson.form_design;

      this.selectedForm.content = this.formBuilderService.generateHtml();
    } catch (error) {
      console.log(error)
    }
  }

  onSaveNewGroup() {
    this.formGroupService.add({
      "name": this.newGroup.name,
      "survey": this.surveyId,
      "groupType": this.newGroup.type
    }).subscribe({
      next: (res: any) => {
        this.isAddNewGroupPopup = false;
        this.newGroup = NEW_GROUP;
        this.groupList.push(res.data)
      },
      error: console.log
    })
  }

  listGroups() {
    this.formGroupService.list(this.surveyId!).subscribe({
      next: (res: any) => {
        this.groupList = res.data.map((o: any) => {
          o.group = true;
          return o
        })
        this.formAndGroupList = this.formList.concat(this.groupList).sort((a, b) => (a.seqNo - b.seqNo))
      },
      error: console.log
    })
  }

  deleteSurvey() {
    this.surveyService.delete(this.surveyId!).subscribe({
      next: (res) => {
        this.router.navigate([APP_ROUTES.SURVEY])
      },
      error: (error) => { }
    })
  }

  updateFormReorder(formList: any) {
    let forms: any = [], groups: any = [];

    formList.forEach((ele: any, i: Number) => {
      (ele.group ? groups : forms).push({
        _id: ele._id,
        seqNo: i
      })
    });

    this.surveyService.reorder(this.surveyId!, {
      forms,
      formGroups: groups
    }).subscribe({
      next: (res) => {
        AppNotification.success('Saved!')
      },
      error: (error) => {
        AppNotification.error('Some Error!')
      }
    })
  }

  onSaveFormGroupRename() {
    if (!this.editGroupPopup.group) return

    this.formGroupService.update(this.editGroupPopup.group._id, {
      name: this.editGroupPopup.newName
    }).subscribe({
      next: (res) => {
        AppNotification.success('Saved!')
        this.editGroupPopup.group.name = this.editGroupPopup.newName
        this.editGroupPopup = {
          visible: false
        }
      },
      error: (error) => {
        AppNotification.error('Some Error!')
        this.editGroupPopup = {
          visible: false
        }
      }
    })
  }

  onDeleteFormGroup(group: any) {
    this.formGroupService.delete(group._id).subscribe({
      next: (res) => {
        AppNotification.success('Deleted!')
        this.listGroups()
      },
      error: (error) => {
        AppNotification.error('Some Error!')
      }
    })
  }
}
